import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";

const BookPHXHyattAdvancedrez = () => {
  return (
    <div className="min-h-screen bg-white">
      <Navbar />
      <main className="container mx-auto px-4 py-20">
        <div className="max-w-6xl mx-auto">
          <div className="text-center mb-8">
            <h1 className="font-montserrat text-4xl md:text-5xl lg:text-6xl font-extrabold text-foreground mb-6">
              Book a Quiet Corner Pod
            </h1>
            <p className="text-lg text-gray-600 mb-8">
              Reserve your private workspace pod for focused work sessions
            </p>
          </div>
          
          <div className="w-full bg-secondary rounded-2xl p-4 md:p-8">
            <iframe 
              src="https://quietcove.wiseingress.com/#/catalog;uid=175D7209-4831-45B1-9372-56D1C4253D22;source=iframe" 
              className="w-full min-h-[2200px] md:min-h-[2000px] lg:min-h-[1800px] rounded-lg"
              style={{ border: 0 }}
              title="Book a Quiet Corner Pod - PHX Hyatt Regency"
              scrolling="no"
            />
          </div>
        </div>
      </main>
      <Footer />
    </div>
  );
};

export default BookPHXHyattAdvancedrez;
